import { Button, Icon, Typography } from "@st-marketplace/ui";

interface OrderDetailsInfoBalanceScreenshotProps {
	src: string;
	title: string;
}
const OrderDetailsInfoBalanceScreenshot = ({
	src,
	title,
}: OrderDetailsInfoBalanceScreenshotProps) => {
	const handleDownload = () => {
		const link = document.createElement("a");
		link.href = src;
		link.download = `screenshot-${Date.now()}.png`;
		document.body.appendChild(link);
		link.click();
		document.body.removeChild(link);
	};

	return (
		<div>
			<Typography variant="title-sm" className="mb-2">
				{title}
			</Typography>

			<div className="flex items-center gap-4">
				<div className="flex-1">
					<img src={src} alt="screenshot" className="block h-auto w-full" />
				</div>

				<div className="shrink-0">
					<Button
						type="button"
						icon
						color="ghost"
						size="sm"
						aria-label={title}
						onClick={handleDownload}
					>
						<Icon name="download-line" size="lg" />
					</Button>
				</div>
			</div>
		</div>
	);
};

export default OrderDetailsInfoBalanceScreenshot;
